/*
Unfortunately when the raw data was first authored, it was done in a way that
is too React-specific instead of sticking with the (acknowledgedly wonky) SVG
attributes that have a mix of camelCase and hyphenations. (See
https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute.)

For example, we use "props" instead of "attributes" and incorrectly use
camelCase for attributes such as `clipRule` instead of using "clip-rule" and
`fillRule` instead of "fill-rule". As such, we end up with a strange mix of not
really "raw" SVG data :(
*/

const attributeReplacements = {
  clipRule: "clip-rule",
  fillRule: "fill-rule"
};
const getAttributeName = prop => attributeReplacements[prop] || prop;
const propsToString = props => Object.keys(props).reduce((accumulator, currentProp) => accumulator += `${getAttributeName(currentProp)}="${props[currentProp]}" `, "").trim();
const typeSpecificDefaultProps = {
  svg: {
    style: `width: 1em; height: 1em;`
  },
  path: {
    fill: "currentColor"
  }
};
const toHTMLString = ({
  type,
  props,
  children
}) => {
  const mergeAllTheThings = {
    ...props,
    ...typeSpecificDefaultProps[type]
  };
  if (children) {
    return `<${type} ${propsToString(mergeAllTheThings)}>${children.map(item => toHTMLString(item)).join("")}</${type}>`; // prettier-ignore
  } else {
    return `<${type} ${propsToString(mergeAllTheThings)}></${type}>`;
  }
};
export default toHTMLString;